// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file consts/commonconsts.proto (package aurora.core.consts.common, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file consts/commonconsts.proto.
 */
export const file_consts_commonconsts: GenFile = /*@__PURE__*/
  fileDesc("Chljb25zdHMvY29tbW9uY29uc3RzLnByb3RvEhlhdXJvcmEuY29yZS5jb25zdHMuY29tbW9uKhwKBFNpZGUSCgoGQk9SUk9XEAASCAoETE9BThABQilaJ2dpdGxhYi5wcnZibC5jb20vYXVyb3JhL2NvcmUvc3JjL2NvbnN0c2IGcHJvdG8z");

/**
 * @generated from enum aurora.core.consts.common.Side
 */
export enum Side {
  /**
   * @generated from enum value: BORROW = 0;
   */
  BORROW = 0,

  /**
   * @generated from enum value: LOAN = 1;
   */
  LOAN = 1,
}

/**
 * Describes the enum aurora.core.consts.common.Side.
 */
export const SideSchema: GenEnum<Side> = /*@__PURE__*/
  enumDesc(file_consts_commonconsts, 0);

